module.exports = __webpack_public_path__ + "d8518b61b6d26b861a6ec7850a64150c.png";